import { createAPI } from '@common'

export default {
  // 位置监控监控
  postTasksLocateConfig: config => createAPI('customEncryptApiName-1/0w20ubtlt0mpdbuf0dpogjh', 'post', config)
}
